export const DocumentKeyEnum = {
  IncidentReport: 1,
  ToolboxTalk: 2,
  VehicleDocument: 3,
  VehicleChecklist: 4,
  CompanyDocument: 5,
};
